<template src="./quiz-fix-by-ai.html"></template>

<script>
  import appHeader from "../../../shared-module/components/app-header/app-header.vue";
  import quizFixByAiService from "../../services/quiz-fix-by-ai-service.js";
  import quizService from "../../services/quiz-service.js";
  import quizConfigurationService from "../../services/quiz-configuration-service.js";
  import courseTopicService from "../../services/course-topic-service.js";
  import courseSubTopicService from "../../services/course-sub-topic-service.js";
  import storageService from "../../services/storage-service.js";
  import ClickOutside from "vue-click-outside";
  import { io } from "socket.io-client";
  import _ from "lodash";
  export default {
    name: "app-quiz-fix-by-ai",
    components: {
      "app-header": appHeader,
    },
    directives: {
      ClickOutside,
    },
    data() {
      return {
        expandedChapter: 1,
        currentView: 'input',
        activeFilter: 'all',
        showEditModal: false,
        showTagDropdown: false,
        tagSearchQuery: '',
        isLoading: false,
        loadingProgress: 0,
        loadingTitle: 'Generating Questions',
        loadingMessage: 'AI is analyzing your prompt and generating MCQs...',
        loadingInterval: null,
        aiModels: [
          { value: 'gpt-4o-mini', label: 'GPT 4o-mini' },
          { value: 'gpt-5-mini', label: 'GPT 5-mini' },
          { value: 'gpt-5.2', label: 'GPT 5.2' },
          { value: 'gpt-5.2-2025-12-11', label: 'GPT 5.2-2025-12-11' },
        ],
        availableTags: [
          'Microscopy',
          'Centrifugation',
          'Staining Techniques',
          'Cell Fractionation',
          'Chromatography',
          'Electrophoresis',
          'PCR',
          'Gel Electrophoresis',
          'Spectrophotometry',
          'Ultracentrifugation'
        ],
        filteredAvailableTags: [],
        
        chapters: [
          { 
            id: 1, 
            name: 'Cell Structure and Function', 
            questionCount: 450,
            topics: [
              {
                id: 1,
                number: '1.1',
                name: 'Techniques used in Cell Biology',
                questionCount: 85,
                selectedSubject: 'MDCAT Biology',
                selectedChapter: 'Cell Biology',
                linkedTopics: ['Microscopy', 'Staining Techniques', 'Centrifugation', 'Cell Fractionation'],
                systemPrompt: '',
                hasResults: true
              }
            ]
          },
          { id: 2, name: 'Biological Molecules', questionCount: 325, topics: [] },
          { id: 3, name: 'Enzymes', questionCount: 180, topics: [] },
          { id: 4, name: 'Bioenergetics', questionCount: 210, topics: [] },
          { id: 5, name: 'Acellular Life (Viruses)', questionCount: 145, topics: [] },
          { id: 6, name: 'Prokaryotes (Kingdom Monera)', questionCount: 195, topics: [] }
        ],
        
        filters: [
          { key: 'all', label: 'All Results', count: 85, colorClass: 'dark' },
          { key: 'approved', label: 'Approved', count: 72, colorClass: 'green' },
          { key: 'flagged', label: 'Flagged', count: 10, colorClass: 'red' },
          { key: 'unprocessed', label: 'Unprocessed', count: 3, colorClass: 'gray' }
        ],
        
        questions: [
          { id: 1, number: 1, text: 'Which of the following techniques is most suitable for separating cell components based on their density?', status: 'approved' },
          { id: 2, number: 2, text: 'Identify the correct statement regarding electron microscopy resolution power and its relation to wavelength.', status: 'flagged' },
          { id: 3, number: 3, text: 'The resolution power of a light microscope is primarily limited by the wavelength of visible light.', status: 'approved' }
        ],
        
        questionTypes: ['Knowledge', 'Understanding', 'Application'],
        
        editingQuestion: {
          number: 1,
          text: 'Which of the following techniques is most suitable for separating cell components based on their density?',
          type: 'Knowledge',
          options: [
            { letter: 'A', text: 'Microscopy', isCorrect: false },
            { letter: 'B', text: 'Centrifugation', isCorrect: true },
            { letter: 'C', text: 'Chromatography', isCorrect: false },
            { letter: 'D', text: 'Electrophoresis', isCorrect: false }
          ],
          tags: ['Centrifugation']
        },

        // Configuration/Topic/Subtopic management
        instructorId: null,
        configurations: [],
        allConfigurations: [], // Store all fetched configs for filtering
        topics: [],
        allTopics: [], // Store all fetched topics for filtering
        subtopics: [],
        allSubtopics: [], // Store all fetched subtopics for filtering
        configSearch: '',
        topicSearch: '',
        subtopicSearch: '',
        loadingConfigs: false,
        loadingTopics: false,
        loadingSubtopics: false,
        activeDropdowns: {}, // Track which topic has which dropdown open: { topicId: { config: true, topic: false, subtopic: false } }
        configsFetched: false, // Track if configs have been fetched
        topicsFetchedFor: {}, // Track which config_ids we've fetched topics for
        subtopicsFetchedFor: {}, // Track which topic_ids we've fetched subtopics for
        socket: null,
        currentProcessingTopic: null,
        editingTopic: null,
        activeTopicId: null,
        userDetails: null,
        
        // Previous Results
        submissions: [],
        loadingSubmissions: false,
        selectedSubmissionId: null,
        globalTopic: null,
        isBatchProcessing: false, // Flag for Approve All flow
        batchQueue: [], // Queue for batch processing
        customAlert: {
          visible: false,
          title: '',
          message: '',
          type: 'info',
          confirmText: 'OK',
          onConfirm: null
        },
        
        // Course Quizzes Data
        courseQuizzes: [],
        expandedCourse: null,
        loadingCourseQuizzes: false,
        
        // Abort functionality
        currentBatchId: null,
        isAborting: false,
        loadingTagQuestions: false,
      }
    },
  
    computed: {
      filteredQuestions() {
        if (this.activeFilter === 'all') {
          return this.questions
        }
        return this.questions.filter(q => q.status === this.activeFilter)
      }
    },
    
    mounted() {
      this.instructorId = storageService.get("uid");
      this.getUserDetails();
      this.fetchConfigurations();
      this.fetchTagQuestions();
      this.fetchCourseQuizzes();

      this.socket = io(process.env.VUE_APP_SOCKET_URL, {
          path: "/quizservice/socket/ai-validation",
          query: {
          userId: this.instructorId
        },
          transports: ["websocket"],
        });
      
      this.socket.on('connect', () => {
        console.log('Socket connected to ai-validation namespace');
      });

      this.socket.on('ai_validation_progress', (data) => {          
          // Cap progress at 99% during processing to avoid "stuck at 100%" state
          let progress = data.progress || 0;
          if (progress >= 100) progress = 99;
          this.loadingProgress = progress;

          // Construct detailed message if details exist
          if (data.details && data.details.total_questions) {
             const { processed_count, skipped_count, flagged_count, total_questions } = data.details;
             const handled = processed_count + skipped_count;
             let msg = `Processed ${handled}/${total_questions} questions`;
             if (skipped_count > 0) msg += ` (${skipped_count} skipped)`;
             if (flagged_count > 0) msg += ` | ${flagged_count} flagged`;
             msg += '...';
             this.loadingMessage = msg;
          } else {
             this.loadingMessage = data.message || this.loadingMessage;
          }

          if (!this.isLoading) this.isLoading = true;
      });

      this.socket.on('ai_validation_complete', (response) => {
          
          if (response && response.status === 'completed') {
            this.loadingProgress = 100;
            this.currentBatchId = null; // Reset batch ID on completion
            
            if (response.data && response.data.results) {
              
              if (response.data.submission) {
                  this.selectedSubmissionId = response.data.submission._id;
              }

              const submission = response.data.submission;
              let topic = this.currentProcessingTopic;
              
              // Check if this is a quiz-type submission
              if (submission && submission.type === 'quiz' && submission.quiz_id) {
                  // Find the quiz in courseQuizzes
                  let foundQuiz = null;
                  for (const course of this.courseQuizzes) {
                      // Note: quiz_id in submission might be the actual Quiz ObjectId from DB
                      // Our quiz objects use `id` (index) but we can match by the context
                      // Since currentProcessingTopic is set to the quiz object when starting
                      if (this.currentProcessingTopic && this.currentProcessingTopic.name) {
                          foundQuiz = this.currentProcessingTopic;
                          break;
                      }
                  }
                  
                  if (foundQuiz || topic) {
                      const targetQuiz = foundQuiz || topic;
                      this.processQuizResults(response.data.results, targetQuiz);
                      targetQuiz.hasResults = true;
                      this.currentView = 'results';
                      this.$forceUpdate();
                      
                      setTimeout(() => {
                          this.isLoading = false;
                          this.$toast.success(`AI Validation Completed: ${response.data.submission.flagged_count} flagged`);
                      }, 500);
                  } else {
                      console.error('Could not find quiz to display results');
                      this.$toast.error('Validation completed but could not locate quiz.');
                      this.isLoading = false;
                  }
              } else {
                  // Original sw_tags flow
                  // Fallback: Find topic by module_tag_id if not set
                  if (!topic && submission && submission.module_tag_id) {
                     const tagId = submission.module_tag_id;
                     for (const chapter of this.chapters) {
                       const found = chapter.topics.find(t => t._id === tagId);
                       if (found) {
                         topic = found;
                         // Ensure chapter is expanded
                         this.expandedChapter = chapter.id;
                         break;
                       }
                     }
                  }
                  
                  if (topic) {
                    this.processResults(response.data.results, topic);
                    topic.hasResults = true;
                    this.currentView = 'results';
                    this.$forceUpdate();
                    
                    setTimeout(() => {
                      this.isLoading = false;
                      this.$toast.success('AI Validation Completed');
                    }, 500);
                  } else {
                    console.error('Could not find topic to display results.');
                    this.$toast.error('Validation completed but could not locate topic.');
                    this.isLoading = false;
                  }
              }
            } else {
              console.warn('No results found in response data');
              this.isLoading = false;
            }
          } else {
             console.warn('AI Validation Complete but status is not completed:', response ? response.status : 'null');
          }
      });

      this.socket.on('ai_validation_error', (data) => {
          console.error('AI Error:', data);
          this.isLoading = false;
          this.currentBatchId = null;
          this.$toast.error('AI Validation Failed: ' + (data.error || 'Unknown error'));
      });
      
      // Abort listener
      this.socket.on('ai-validation-aborted', (data) => {
          console.log('AI Validation Aborted:', data);
          this.isLoading = false;
          this.isAborting = false;
          
          // Store submission ID if available (needed for editing questions)
          // Use data.batchId (from backend) or fallback to currentBatchId (same thing)
          if (data.batchId) {
              this.selectedSubmissionId = data.batchId;
          } else if (this.currentBatchId) {
              this.selectedSubmissionId = this.currentBatchId;
          }
          
          this.currentBatchId = null;
          
          // Show partial results if available
          if (data.results && data.results.length > 0) {
              const topic = this.currentProcessingTopic;
              if (topic) {
                  // Construct submission details for banner
                  const details = {
                      status: 'aborted',
                      total_questions: data.total_questions,
                      processed_count: data.processed_count,
                      flagged_count: data.flagged_count,
                      skipped_count: data.skipped_count
                  };
                  
                  // Check if quiz or sw_tag type
                  if (topic.selectedTopics) {
                      this.processQuizResults(data.results, topic);
                      topic.submissionDetails = details;
                  } else {
                      this.processResults(data.results, topic);
                      topic.submissionDetails = details;
                  }
                  topic.hasResults = true;
                  this.currentView = 'results';
                  this.$forceUpdate();
              }
          }
          
          this.$toast.warning(data.message || 'AI Validation was aborted');
      });

      // Duplicate Questions Listeners
      this.socket.on("duplicate_questions_progress", (data) => {
        // data structure: { step: number, message: string }
        
        this.loadingMessage = data.message;
        // Map steps 1-3 to progress percentage (approximate)
        if (data.step === 1) this.loadingProgress = 33;
        if (data.step === 2) this.loadingProgress = 66;
        if (data.step === 3) this.loadingProgress = 90;
      });

      this.socket.on("duplicate_questions_complete", (response) => {
        
        if (this.editingTopic && this.editingTopic.questions && this.editingQuestion) {
           const questionToUpdate = this.editingTopic.questions.find(q => q.id === this.editingQuestion.id);
           if (questionToUpdate) {
             // Update local state to show "Updated" icon immediately
             this.$set(questionToUpdate, 'isUpdated', true);
             
             // Update other fields to show new data without refresh
             this.$set(questionToUpdate, 'options', this.editingQuestion.options);
             this.$set(questionToUpdate, 'tags', this.editingQuestion.tags);
             this.$set(questionToUpdate, 'type', this.editingQuestion.type);
             
             // Update image URLs to reflect any new uploads
             this.$set(questionToUpdate, 'imageUrl', this.editingQuestion.imageUrl);
             this.$set(questionToUpdate, 'solutionImageUrl', this.editingQuestion.solutionImageUrl);
             
             // Update the text fields
             this.$set(questionToUpdate, 'text', this.editingQuestion.text);
             this.$set(questionToUpdate, 'aiSolution', this.editingQuestion.aiSolution);
             this.$set(questionToUpdate, 'solutionText', this.editingQuestion.solutionText);
             
             // Handle User Approval State - preserve the flag for filtering
             if (this.editingQuestion.isUserApproved) {
                 this.$set(questionToUpdate, 'isUserApproved', true);
             }
             
             // Always set status to 'updated' when question is updated
             // The isUserApproved flag handles the "Approved (User)" filter separately
             this.$set(questionToUpdate, 'status', 'updated');
             
             // Update counts immediately
             this.updateTopicCounts(this.editingTopic);
           }
           
           // Update aiStats from response if available
           if (response && response.ai_stats) {
             this.$set(this.editingTopic, 'aiStats', response.ai_stats);
           }
        }
        
        if (this.isBatchProcessing) {
             // Remove the processed item
             this.batchQueue.shift();
             
             if (this.batchQueue.length > 0) {
                 this.processNextBatchItem();
             } else {
                 this.isBatchProcessing = false;
                 this.isLoading = false;
                 this.loadingProgress = 100;
                 this.editingQuestion = null;
                 this.$toast.success("All approved questions updated successfully!");
             }
        } else {
             this.isLoading = false;
             this.loadingProgress = 100;
             this.$toast.success("Successfully updated duplicate questions!");
             this.closeModal();
        }
      });

      this.socket.on("duplicate_questions_error", (error) => {
        console.error("Error:", error.message);
        this.isLoading = false;
        if (this.isBatchProcessing) {
             this.isBatchProcessing = false;
             this.batchQueue = [];
             this.$toast.error(`Batch processing stopped: ${error.message}`);
        } else {
             this.$toast.error(`Failed: ${error.message}`);
        }
      });
    },
    
    watch: {
        'editingQuestion.aiSolution': function() {
            this.$nextTick(() => {
                this.applyMathQuill();
            });
        }
    },
    methods: {
      // debouncedFetchConfigurations: _.debounce(function(quiz) {
      //    const searchTerm = quiz ? quiz.configSearch : this.configSearch; // Fallback
      //    this.fetchConfigurations(searchTerm);
      // }, 500),

      async fetchTagQuestions() {
        this.loadingTagQuestions = true
        this.error = null

        try {
          const response = await quizFixByAiService.getTagQuestions()
          if (response.data.success) {
            this.chapters = response.data.course.map((course, index) => ({
              id: index + 1,
              name: course.name,
              questionCount: course.questions,
              topics: course.moduleTags.map((tag, tagIndex) => {
                // Extract configuration and topic from course_topics
                const courseTopics = tag.course_topics || [];
                const linkedConfiguration = courseTopics.find(ct => ct.type === 'configuration');
                const linkedTopic = courseTopics.find(ct => ct.type === 'topic');
                
                return {
                  id: tagIndex + 1,
                  number: tagIndex + 1,
                  _id: tag._id,
                  name: tag.name,
                  questionCount: tag.questions,
                  course_topics: courseTopics,
                  linkedConfiguration: linkedConfiguration || null,
                  linkedTopic: linkedTopic || null,
                  aiStats: tag.ai_stats || null,
                  selectedAIModel: 'gpt-5.2-2025-12-11', // Default model
                  activeDropdown: { config: false, topic: false, subtopic: false, aiModel: false }, // Add aiModel dropdown state
                  isExpanded: false // Accordion state
                };
              })
            }))
          } else {
            this.error = 'Failed to load data'
          }
        } catch (err) {
          this.error = 'An error occurred while fetching data'
        } finally {
          this.loadingTagQuestions = false
        }
      },
      
      async abortAIValidation() {
        if (!this.currentBatchId) {
            this.$toast.error('No active validation to abort');
            return;
        }
        
        this.isAborting = true;
        this.loadingMessage = 'Aborting AI Validation...';
        
        try {
            const response = await quizFixByAiService.abortBatch(this.currentBatchId);
            if (response.data && response.data.status === 'success') {
                // The socket event 'ai-validation-aborted' will handle the rest
                this.$toast.info('Abort request sent. Waiting for confirmation...');
            } else {
                this.isAborting = false;
                this.$toast.error('Failed to abort validation');
            }
        } catch (error) {
            console.error('Error aborting validation:', error);
            this.isAborting = false;
            this.$toast.error('Error aborting validation');
        }
      },
      
      async fetchCourseQuizzes() {
        this.loadingCourseQuizzes = true;
        try {
          const response = await quizFixByAiService.getCourseQuizzesCount(this.instructorId);
          if (response && response.data && response.data.status === 'success') {
             this.courseQuizzes = response.data.data.map((item, index) => {
               // Calculate total questions for the course
               const totalQuestions = item.quizzes.reduce((sum, quiz) => sum + (quiz.question_count || 0), 0);
               return {
                 id: item.course.id,
                 name: item.course.name,
                 questionCount: totalQuestions,
                 quizzes: item.quizzes.map((quiz, qIndex) => {
                   // Extract configuration and topic from course_topics if available
                   const courseTopics = quiz.course_topics || [];
                   const linkedConfiguration = courseTopics.find(ct => ct.type === 'configuration');
                   const linkedTopic = courseTopics.find(ct => ct.type === 'topic');
                   
                   return {
                     id: qIndex + 1,
                     _id: quiz._id,
                     name: quiz.name,
                     questionCount: quiz.question_count,
                     course_topics: courseTopics,
                     linkedConfiguration: linkedConfiguration || null,
                     linkedTopic: linkedTopic || null,
                     aiStats: quiz.ai_stats || null,
                     // Multi-select State
                     selectedConfigurations: [], // Array of { _id, name }
                     selectedTopics: [],         // Array of { _id, name }
                     selectedSubtopics: [],      // Array of { _id, name }
                     selectedAIModel: 'gpt-5.2-2025-12-11', // Default model
                     systemPrompt: '',
                     activeDropdown: { config: false, topic: false, subtopic: false, aiModel: false },
                     configSearch: '',
                     topicSearch: '',
                     subtopicSearch: '',
                     availableTopics: [],
                     availableSubtopics: [],
                     expanded: false // Add expansion state
                   };
                 })
               };
             });
          }
        } catch (error) {
          console.error("Error fetching course quizzes", error);
          this.$toast.error("Failed to fetch course quizzes");
        } finally {
          this.loadingCourseQuizzes = false;
        }
      },

      // --- Course Quiz Multi-select Methods ---

      toggleCourseQuizDropdown(quiz, type) {
        // specific toggle for course quiz items
        // close others in this quiz
        Object.keys(quiz.activeDropdown).forEach(k => {
          if (k !== type) quiz.activeDropdown[k] = false;
        });
        quiz.activeDropdown[type] = !quiz.activeDropdown[type];
        
        if (quiz.activeDropdown[type]) {
            if (type === 'config') {
                quiz.configSearch = '';
                // Configs are fetched globally on mount, no need to re-fetch
            } else if (type === 'topic') {
                quiz.topicSearch = '';
                // Only fetch if no topics loaded yet for this quiz
                if (quiz.availableTopics.length === 0 && quiz.selectedConfigurations.length > 0) {
                    this.fetchTopicsForQuiz(quiz);
                }
            } else if (type === 'subtopic') {
                quiz.subtopicSearch = '';
                // Only fetch if no subtopics loaded yet
                if (quiz.availableSubtopics.length === 0 && quiz.selectedTopics.length > 0) {
                    this.fetchSubtopicsForQuiz(quiz);
                }
            }
        }
      },

      hideCourseQuizDropdown(quiz, type) {
        if(quiz && quiz.activeDropdown) {
           quiz.activeDropdown[type] = false;
        }
      },
      
      selectQuizConfiguration(quiz, config) {
        // Toggle selection
        const index = quiz.selectedConfigurations.findIndex(c => c._id === config._id);
        if (index === -1) {
            quiz.selectedConfigurations.push(config);
        } else {
             quiz.selectedConfigurations.splice(index, 1);
        }
        
        // Always refresh topics based on new selection state
        this.fetchTopicsForQuiz(quiz);
        quiz.configSearch = '';
        this.fetchConfigurations(''); // Reset list to show all configurations
      },

      removeQuizConfiguration(quiz, index) {
        quiz.selectedConfigurations.splice(index, 1);
        // Refresh topics
        this.fetchTopicsForQuiz(quiz);
        // Also remove any selected topics that no longer belong to selected configs? 
        // For simplicity, we might keep them or filter them. 
        // Ideally, we should filter out topics that are no longer valid.
        // But checking validity requires knowing which config a topic belongs to.
        // The topic object from API usually has configuration_id.
        if (quiz.availableTopics.length > 0) {
             const selectedConfigIds = quiz.selectedConfigurations.map(c => c._id);
             quiz.selectedTopics = quiz.selectedTopics.filter(t => selectedConfigIds.includes(t.configuration_id));
        } else {
             quiz.selectedTopics = [];
        }
        // And subtopics...
        quiz.availableTopics = quiz.availableTopics.filter(t => quiz.selectedConfigurations.some(c => c._id === t.configuration_id));
      },

      async loadMoreTopics(quiz) {
         if (!quiz.topicHasMore || this.loadingTopics) return;
         quiz.topicPage += 1;
         await this.fetchTopicsForQuiz(quiz, quiz.topicPage);
      },

      async fetchTopicsForQuiz(quiz, page = 1) {
         if (quiz.selectedConfigurations.length === 0) {
             quiz.availableTopics = [];
             return;
         }
         
         this.loadingTopics = true;
         
         // Initialize pagination if page 1
         if (page === 1) {
            quiz.topicPage = 1;
            quiz.topicHasMore = true;
            // quiz.availableTopics = []; // Clear current list on new search/reset
         }

         try {
             // Pass array of IDs directly to service
             // Use pagination: page, limit=10 (default)
             const limit = 10;
             const configIds = quiz.selectedConfigurations.map(c => c._id);
             const response = await courseTopicService.getAllTopics(configIds, quiz.topicSearch, "", page, limit);
             
             if (response && response.data && response.data.docs) {
                 const newTopics = response.data.docs;
                 
                 if (page === 1) {
                     quiz.availableTopics = newTopics;
                 } else {
                     // Append new topics, deduplicating just in case
                     const currentIds = new Set(quiz.availableTopics.map(t => t._id));
                     const filteredNew = newTopics.filter(t => !currentIds.has(t._id));
                     quiz.availableTopics = [...quiz.availableTopics, ...filteredNew];
                 }
                 
                 // Check if we have more
                 quiz.topicHasMore = newTopics.length === limit;
             } else {
                 if (page === 1) quiz.availableTopics = [];
                 quiz.topicHasMore = false;
             }
             
         } catch (e) {
             console.error(e);
             this.$toast.error("Failed to fetch topics");
         } finally {
             this.loadingTopics = false;
         }
      },
      
      toggleQuiz(quiz) {
        quiz.expanded = !quiz.expanded;
      },

      selectQuizTopic(quiz, topic) {
         const exists = quiz.selectedTopics.some(t => t._id === topic._id);
         if (!exists) {
             quiz.selectedTopics.push(topic);
             this.fetchSubtopicsForQuiz(quiz);
         }
         quiz.topicSearch = '';
         this.fetchTopicsForQuiz(quiz); // Reset list to show all topics
      },

      removeQuizTopic(quiz, index) {
         quiz.selectedTopics.splice(index, 1);
         this.fetchSubtopicsForQuiz(quiz);
      },
      
      async fetchSubtopicsForQuiz(quiz) {
         if (quiz.selectedTopics.length === 0) {
             quiz.availableSubtopics = [];
             return;
         }
         
         // Get all topic IDs as array
         const topicIds = quiz.selectedTopics.map(topic => topic._id);
         
         // Single API call with all topic IDs
         const response = await courseSubTopicService.getAllSubTopics(topicIds, quiz.subtopicSearch);
         
         if (response && response.data && response.data.docs) {
             // Deduplicate subtopics by _id
             const uniqueSub = new Map();
             response.data.docs.forEach(s => uniqueSub.set(s._id, s));
             quiz.availableSubtopics = Array.from(uniqueSub.values());
         } else {
             quiz.availableSubtopics = [];
         }
      },
      
      selectQuizSubtopic(quiz, subtopic) {
          const exists = quiz.selectedSubtopics.some(s => s._id === subtopic._id);
          if(!exists) {
              quiz.selectedSubtopics.push(subtopic);
          }
          quiz.subtopicSearch = '';
          quiz.activeDropdown.subtopic = false; // Close after select? Or keep open for multi? Let's keep open for consistency if other two are multi.
          // Actually user didn't explicitly ask for multi sub-topic but "Input Form" has it as multi-select linked tags. 
          // Previous impl uses `toggleTagDropdown` for tagging.
      },

      removeQuizSubtopic(quiz, index) {
          quiz.selectedSubtopics.splice(index, 1);
      },

      async saveAndRunAICourseQuiz(quiz) {
        if (quiz.selectedConfigurations.length === 0 || quiz.selectedTopics.length === 0) {
             this.$toast.error('Please select at least one Configuration and Topic');
             return;
        }

        this.currentProcessingTopic = quiz; // Treat quiz as "topic" context for loading handling
        this.isLoading = true;
        this.loadingProgress = 0;
        this.loadingTitle = 'Initiating AI Validation';
        this.loadingMessage = 'Sending request...';

        try {
            const payload = {
                configuration_id: quiz.selectedConfigurations.map(c => c._id), // Array
                topic_id: quiz.selectedTopics.map(t => t._id), 
                quiz_id: quiz._id,
                explicit_user_prompt: quiz.systemPrompt || "",
                created_by: this.instructorId,
                type: "quiz",
                ai_model: quiz.selectedAIModel
            };
            
            // NOTE: I am sending arrays for config_id and topic_id.
            
            const response = await quizFixByAiService.startAIValidation(payload);

            if (response.data && response.data.status === 'success') {
                // Store submission ID for abort functionality
                if (response.data.data && response.data.data.submission) {
                    this.currentBatchId = response.data.data.submission._id;
                }
                this.loadingMessage = 'Request queued. Waiting for AI...';
                this.$toast.success('AI Validation Started');
            } else {
                this.isLoading = false;
                this.$toast.error('Failed to start AI validation');
            }
        } catch (error) {
            console.error(error);
            this.isLoading = false;
            this.$toast.error('Error starting AI validation');
        }
      },

      isConfigSelected(quiz, config) {
        return quiz.selectedConfigurations.some(c => c._id === config._id);
      },

      isTopicSelected(quiz, topic) {
        return quiz.selectedTopics.some(t => t._id === topic._id);
      },

      filteredConfigurations(search) {
        if (!search) return this.configurations;
        return this.configurations.filter(c => c.name.toLowerCase().includes(search.toLowerCase()));
      },

      filteredQuizTopics(quiz) {
        if (!quiz.topicSearch) return quiz.availableTopics;
        return quiz.availableTopics.filter(t => t.name.toLowerCase().includes(quiz.topicSearch.toLowerCase()));
      },
      
      toggleCourse(id) {
         this.expandedCourse = this.expandedCourse === id ? null : id;
      },

      toggleChapter(id) {
        this.expandedChapter = this.expandedChapter === id ? null : id
      },
      
      showResults(topic) {
        this.currentView = 'results'
      },

      async showPreviousResults(topic) {
        this.loadingSubmissions = true;
        this.currentView = 'submissions';
        this.$set(topic, 'isExpanded', true);
        this.currentProcessingTopic = topic;
        
        try {
          const response = await quizFixByAiService.getAllSubmissions(topic._id, this.instructorId);
          if (response && response.data) {
            this.submissions = response.data.data.map((submission, index) => ({
              ...submission,
              displayName: `Result ${index + 1}`,
              createdAt: submission.created_at
            }));
          } else {
            this.$toast.error('Failed to fetch previous results');
          }
        } catch (error) {
          console.error('Error fetching submissions:', error);
          this.$toast.error('Error loading previous results');
        } finally {
          this.loadingSubmissions = false;
        }
      },

      async showPreviousQuizResults(quiz) {
        this.loadingSubmissions = true;
        this.$set(quiz, 'currentView', 'submissions');
        this.$set(quiz, 'expanded', true);
        this.currentProcessingTopic = quiz;
        
        try {
          // Use quiz._id to fetch submissions for this quiz
          const response = await quizFixByAiService.getQuizSubmissions(quiz._id, this.instructorId);
          if (response && response.data) {
            this.$set(quiz, 'submissions', response.data.data.map((submission, index) => ({
              ...submission,
              displayName: `Result ${index + 1}`,
              createdAt: submission.created_at
            })));
          } else {
            this.$set(quiz, 'submissions', []);
            this.$toast.error('Failed to fetch previous results');
          }
        } catch (error) {
          console.error('Error fetching quiz submissions:', error);
          this.$set(quiz, 'submissions', []);
          this.$toast.error('Error loading previous results');
        } finally {
          this.loadingSubmissions = false;
        }
      },

      async viewQuizSubmissionDetails(submission, quiz) {
        this.loadingSubmissions = true;
        this.selectedSubmissionId = submission._id;
        
        try {
          const response = await quizFixByAiService.getSubmissionDetails(submission._id);
          if (response && response.data) {
            this.processQuizResults(response.data.data.results, quiz);
            quiz.submissionDetails = response.data.data.submission; // Store submission details for banner
            quiz.hasResults = true;
            // Ensure quiz stays expanded and switch from submissions view to form/results view
            this.$set(quiz, 'expanded', true);
            this.$set(quiz, 'currentView', null); // Close submissions view, show form with results
            this.$forceUpdate();
          } else {
            this.$toast.error('Failed to fetch submission details');
          }
        } catch (error) {
          console.error('Error fetching submission details:', error);
          this.$toast.error('Error loading submission details');
        } finally {
          this.loadingSubmissions = false;
        }
      },

      async viewSubmissionDetails(submission) {
        this.loadingSubmissions = true;
        this.selectedSubmissionId = submission._id;
        
        try {
          const response = await quizFixByAiService.getSubmissionDetails(submission._id);
          if (response && response.data) {
            const topic = this.currentProcessingTopic;
            if (topic) {
              this.processResults(response.data.data.results, topic);
              topic.submissionDetails = response.data.data.submission; // Store submission details for banner
              this.globalTopic = response.data.data.submission.topic_id;
              this.currentView = 'results';
            }
          } else {
            this.$toast.error('Failed to fetch submission details');
          }
        } catch (error) {
          console.error('Error fetching submission details:', error);
          this.$toast.error('Error loading submission details');
        } finally {
          this.loadingSubmissions = false;
        }
      },
      
      editQuestion(question, topic) {
        // console.log("🚀 ~ topic:", topic)
        this.editingQuestion = _.cloneDeep(question);
        this.editingTopic = topic;
        this.showEditModal = true;
        
        // Determine the topic ID for fetching subtopics
        // Quiz flow: topic.selectedTopics is an array of {_id, name} objects
        // sw_tags flow: topic.selectedTopicId is a single ID
        let effectiveTopicId = null;
        
        if (topic.selectedTopics && topic.selectedTopics.length > 0) {
            // Quiz flow: use cached availableSubtopics if they exist
            effectiveTopicId = topic.selectedTopics.map(t => t._id);
            this.editingQuestion.topicId = effectiveTopicId[0]; // Store first for reference
            this.activeTopicId = effectiveTopicId[0];
            
            // Use cached subtopics from the quiz object
            if (topic.availableSubtopics && topic.availableSubtopics.length > 0) {
                this.subtopics = topic.availableSubtopics;
                return; // Skip API call
            }
        } else if (topic.selectedTopicId) {
            // sw_tags flow
            effectiveTopicId = topic.selectedTopicId;
            this.editingQuestion.topicId = topic.selectedTopicId;
        } else {
            effectiveTopicId = this.globalTopic;
        }
        
        if (effectiveTopicId) {
          this.activeTopicId = Array.isArray(effectiveTopicId) ? effectiveTopicId[0] : effectiveTopicId;
          // Fetch subtopics for the dropdown - pass array or single ID
          this.fetchSubtopics(effectiveTopicId);
        }

        // Render math in modal after it opens
        this.$nextTick(() => {
            this.applyMathQuill();
        });
      },
      
      closeModal() {
        this.showEditModal = false
        this.showTagDropdown = false
        this.tagSearchQuery = ''
      },
      
      setFilter(filterKey) {
        this.activeFilter = filterKey
      },
      
      setQuestionType(type) {
        this.editingQuestion.type = type
      },
      
      switchToInputView() {
        this.currentView = 'input'
      },
      
      selectCorrectAnswer(selectedIndex) {
        this.editingQuestion.options.forEach((option, idx) => {
          option.isCorrect = idx === selectedIndex
        })
      },
      
      toggleTagDropdown() {
        this.showTagDropdown = !this.showTagDropdown
        if (this.showTagDropdown) {
          this.tagSearchQuery = ''
          
          // For quiz flow: use cached availableSubtopics from editingTopic
          if (this.editingTopic && this.editingTopic.availableSubtopics && this.editingTopic.availableSubtopics.length > 0) {
            this.subtopics = this.editingTopic.availableSubtopics;
            return; // Skip API call
          }
          
          // For sw_tags flow or if no cached subtopics: fetch from API
          if (this.activeTopicId) {
             this.fetchSubtopics(this.activeTopicId);
          }
        }
      },

      closeTagDropdown() {
        this.showTagDropdown = false;
      },
      
      filterTags() {
        this.debouncedTagSearch();
      },

      debouncedTagSearch: _.debounce(function() {
          const query = this.tagSearchQuery?.toLowerCase() || '';
          
          // For quiz flow: first filter from cached availableSubtopics
          if (this.editingTopic && this.editingTopic.availableSubtopics && this.editingTopic.availableSubtopics.length > 0) {
              const filtered = this.editingTopic.availableSubtopics.filter(s => 
                  s.name && s.name.toLowerCase().includes(query)
              );
              
              // If local results found, use them without API call
              if (filtered.length > 0 || query === '') {
                  this.subtopics = query === '' ? this.editingTopic.availableSubtopics : filtered;
                  return;
              }
              
              // If not found locally and search query exists, call API with all topic IDs
              if (this.editingTopic.selectedTopics && this.editingTopic.selectedTopics.length > 0) {
                  const topicIds = this.editingTopic.selectedTopics.map(t => t._id);
                  this.fetchSubtopics(topicIds, query);
                  return;
              }
          }
          
          // For sw_tags flow
          if (this.activeTopicId) {
              this.fetchSubtopics(this.activeTopicId, this.tagSearchQuery);
          }
      }, 500),
      
      addTag(tag) {
        const tagName = tag.name || tag;
        const exists = this.editingQuestion.tags.some(t => (t.name || t) === tagName);
        
        if (!exists) {
          this.editingQuestion.tags.push(tag);
        }
        this.showTagDropdown = false
        this.tagSearchQuery = ''
      },
      
      removeTag(index) {
        this.editingQuestion.tags.splice(index, 1)
      },

      approveAll(topic) {
        // console.log("🚀 ~ topic:", topic)
        
        if (!topic || !topic.questions) return;
        
        this.editingTopic = topic; // Set context

        // 1. Check for manually approved questions first
        const userApprovedQuestions = topic.questions.filter(q => q.isUserApproved && !q.isUpdated);
        
        if (userApprovedQuestions.length > 0) {
            this.showAlert(
                'Confirm Updated Questions', 
                `You have manually approved ${userApprovedQuestions.length} questions. Do you want to process them?`, 
                'info', 
                'Process Questions',
                () => {
                    this.batchQueue = [...userApprovedQuestions];
                    this.isBatchProcessing = true;
                    this.processNextBatchItem();
                }
            );
            return;
        }

        // 2. Fallback to AI approved questions
        const approvedQuestions = topic.questions.filter(q => q.status === 'approved' && !q.isUpdated);
        
        if (approvedQuestions.length === 0) {
          this.showAlert('No Questions', 'No approved questions found to update.', 'warning');
          return;
        }
        
        this.showAlert(
            'Confirm Batch Update', 
            `Found ${approvedQuestions.length} AI-approved questions. Do you want to process all of them?`, 
            'info', 
            'Process All',
            () => {
                this.batchQueue = [...approvedQuestions];
                this.isBatchProcessing = true;
                this.processNextBatchItem();
            }
        );
      },

      processNextBatchItem() {
         if (this.batchQueue.length === 0) return;

         const nextQ = this.batchQueue[0];
         
         // Set internal state as if we are editing this question
         // This ensures updateData() and the completion listener work correctly
         this.editingQuestion = _.cloneDeep(nextQ);
         this.editingQuestion.topicId = this.editingTopic.selectedTopicId;
         
         // Trigger the update
         this.updateData();
      },

      async getUserDetails() {
        const userData = await localStorage.getItem("user");
        this.userDetails = JSON.parse(userData);
      },
      
      updateData() {
        if (!this.editingQuestion || !this.editingQuestion.originalResult) {
            this.$toast.error("Invalid question data");
            return;
        }

        this.isLoading = true;
        this.loadingTitle = "Updating Question";
        this.loadingMessage = "Starting update process...";
        this.loadingProgress = 0;

        const originalQuestion = this.editingQuestion.originalResult.question_id;
        
        // Determine topics and configurations based on flow type
        let topicIds = [];
        let configurationIds = [];
        let subtopicIds = this.editingQuestion.tags.map(t => t._id).filter(id => id);
        
        if (this.editingTopic) {
            // Quiz flow: uses selectedConfigurations and selectedTopics (arrays of objects with _id)
            if (this.editingTopic.selectedConfigurations && this.editingTopic.selectedConfigurations.length > 0) {
                configurationIds = this.editingTopic.selectedConfigurations.map(c => c._id);
            }
            if (this.editingTopic.selectedTopics && this.editingTopic.selectedTopics.length > 0) {
                topicIds = this.editingTopic.selectedTopics.map(t => t._id);
            }
            // Quiz flow: also check for selectedSubtopics if tags are empty
            if (subtopicIds.length === 0 && this.editingTopic.selectedSubtopics && this.editingTopic.selectedSubtopics.length > 0) {
                subtopicIds = this.editingTopic.selectedSubtopics.map(s => s._id);
            }
            
            // sw_tags flow: uses selectedConfigurationId and selectedTopicId (single IDs)
            if (configurationIds.length === 0 && this.editingTopic.selectedConfigurationId) {
                configurationIds = [this.editingTopic.selectedConfigurationId];
            }
            if (topicIds.length === 0 && this.editingTopic.selectedTopicId) {
                topicIds = [this.editingTopic.selectedTopicId];
            }

            // Fallback to linkedConfiguration and linkedTopic if still empty
            if (configurationIds.length === 0 && this.editingTopic.linkedConfiguration) {
                console.log('main not selected sending from APis');
                configurationIds = [this.editingTopic.linkedConfiguration._id];
            }
            if (topicIds.length === 0 && this.editingTopic.linkedTopic) {
                console.log('main not selected sending from APis');
                topicIds = [this.editingTopic.linkedTopic._id];
            }
        }
        
        // Final fallback to editingQuestion.topicId or globalTopic for topicIds
        if (topicIds.length === 0) {
            if (this.editingQuestion && this.editingQuestion.topicId) {
                console.log('main not selected sending from APis');
                topicIds = [this.editingQuestion.topicId];
            } else if (this.globalTopic) {
                console.log('main not selected sending from APis');
                topicIds = [this.globalTopic];
            }
        }

        const payload = {
            user_id: this.instructorId,
            original_question_id: originalQuestion._id,
            question: {
                question: this.editingQuestion.text,
                equation: originalQuestion.equation,
                image_url: this.editingQuestion.imageUrl || '',
                solution_image_url: this.editingQuestion.solutionImageUrl || '',
                options: this.editingQuestion.options.map(opt => ({
                    option: opt.text,
                    equation: opt.equation,
                    image_url: opt.imageUrl || '',
                    is_correct: opt.isCorrect,
                    _id: opt._id
                })),
                ai_question_solution: this.editingQuestion.aiSolution || this.editingQuestion.solutionText,
            },
            configuration: configurationIds,
            topics: topicIds,
            subtopics: subtopicIds,
            nature: this.editingQuestion.type,
            submission_id: this.selectedSubmissionId
        };
        
        // Emit the event
        this.socket.emit("start_duplicate_questions", payload);
      },
      async saveAndRunAI(topic) {
        this.currentProcessingTopic = topic;
        this.isLoading = true
        this.loadingProgress = 0
        this.loadingTitle = 'Initiating AI Validation'
        this.loadingMessage = 'Sending request...'
        
        try {
            const payload = {
                configuration_id: topic.selectedConfigurationId,
                topic_id: topic.selectedTopicId,
                module_tag_id: topic._id,
                explicit_user_prompt: topic.systemPrompt || "",
                created_by: this.instructorId,
                type: "sw_tag",
                ai_model: topic.selectedAIModel
            };

            // Validate payload
            if (!payload.configuration_id || !payload.topic_id) {
                 this.$toast.error('Please select Configuration and Topic first');
                 this.isLoading = false;
                 return;
            }

            const response = await quizFixByAiService.startAIValidation(payload);
            
            if (response.data && response.data.status === 'success') {
                // Store submission ID for abort functionality
                if (response.data.data && response.data.data.submission) {
                    this.currentBatchId = response.data.data.submission._id;
                }
                this.loadingMessage = 'Request queued. Waiting for AI...';
                this.$toast.success('AI Validation Started');
            } else {
                this.isLoading = false;
                this.$toast.error('Failed to start AI validation');
            }
        } catch (error) {
            console.error(error);
            this.isLoading = false;
            this.$toast.error('Error starting AI validation');
        }
      },

      // Configuration/Topic/Subtopic Methods
      async loadMoreConfigurations() {
        if (!this.configHasMore || this.loadingConfigs) return;
        this.configPage += 1;
        await this.fetchConfigurations(this.configSearch, this.configPage);
      },

      async fetchConfigurations(search = '', page = 1) {
        if (!this.instructorId) return;

        // Initialize/Reset pagination state for new search or page 1
        if (page === 1) {
             this.configPage = 1;
             this.configHasMore = true;
             // Removed clearing to prevent flicker: this.configurations = [];
        }
        
        this.loadingConfigs = true;
        try {
          const limit = 10;
          // Services updated to accept page/limit
          const response = await quizConfigurationService.getAllConfigurations("", search, false, page, limit);
          if (response && response.data && response.data.docs) {
             const newConfigs = response.data.docs;
             
             if (page === 1) {
               this.configurations = newConfigs;
             } else {
               // Append
               const currentIds = new Set(this.configurations.map(c => c._id));
               const filteredNew = newConfigs.filter(c => !currentIds.has(c._id));
               this.configurations = [...this.configurations, ...filteredNew];
             }
             
             this.configHasMore = newConfigs.length === limit;
          } else {
             if (page === 1) this.configurations = [];
             this.configHasMore = false;
          }
        } catch (error) {
          console.error('Error fetching configurations:', error);
          this.$toast.error('Failed to fetch configurations');
        } finally {
          this.loadingConfigs = false;
        }
      },

      debouncedFetchConfigurations: _.debounce(function(arg) {
         let search = this.configSearch;
         if (arg && arg.configSearch !== undefined) {
             search = arg.configSearch;
         }
         this.fetchConfigurations(search);
      }, 500),

      async loadMoreTagsTopics(configurationId) {
         if (!this.topicHasMore || this.loadingTopics) return;
         this.topicPage += 1;
         await this.fetchTopics(configurationId, this.topicSearch, this.topicPage);
      },

      async fetchTopics(configurationId, search = '', page = 1) {
        if (!configurationId) return;
        
        // No caching logic for now as we prioritize pagination
        // Initialize state for new fetch
        if (page === 1) {
             this.topicPage = 1;
             this.topicHasMore = true;
             // Removed clearing: this.topics = [];
        }
        
        this.loadingTopics = true;
        try {
          const limit = 10;
          const response = await courseTopicService.getAllTopics(configurationId, search, "", page, limit);
          if (response && response.data && response.data.docs) {
             const newTopics = response.data.docs;
             
             if (page === 1) {
                 this.topics = newTopics;
             } else {
                 const currentIds = new Set(this.topics.map(t => t._id));
                 const filteredNew = newTopics.filter(t => !currentIds.has(t._id));
                 this.topics = [...this.topics, ...filteredNew];
             }
             
             this.topicHasMore = newTopics.length === limit;
          } else {
             if (page === 1) this.topics = [];
             this.topicHasMore = false;
          }
        } catch (error) {
          console.error('Error fetching topics:', error);
          this.$toast.error('Failed to fetch topics');
        } finally {
          this.loadingTopics = false;
        }
      },

      debouncedFetchTopics: _.debounce(function(arg) {
         if (arg && typeof arg === 'object' && arg.selectedConfigurations) {
             // Quiz Flow: arg is the quiz object
             this.fetchTopicsForQuiz(arg);
         } else {
             // SW Tags Flow: arg is the configurationId (string)
             this.fetchTopics(arg, this.topicSearch);
         }
      }, 500),

      async fetchSubtopics(topicId, search = '') {
        if (!topicId) return;
        
        // If no search and already fetched, use cache
        if (!search && this.subtopicsFetchedFor[topicId]) {
          this.subtopics = this.allSubtopics.filter(s => {
            // Handle both single topic_id and array
            if (Array.isArray(topicId)) {
              return topicId.includes(s.topic_id);
            }
            return s.topic_id === topicId;
          });
          return;
        }
        
        // If searching, try local filter first
        if (search && this.subtopicsFetchedFor[topicId]) {
          const filtered = this.allSubtopics.filter(s => {
            const matchesTopic = Array.isArray(topicId) 
              ? topicId.includes(s.topic_id)
              : s.topic_id === topicId;
            return matchesTopic && s.name.toLowerCase().includes(search.toLowerCase());
          });
          
          if (filtered.length > 0) {
            this.subtopics = filtered;
            return;
          }
        }
        
        this.loadingSubtopics = true;
        try {
          const response = await courseSubTopicService.getAllSubTopics(topicId, search);
          if (response && response.data && response.data.docs) {
            if (!search) {
              const newSubtopics = response.data.docs;
              // Remove old subtopics for this topic and add new ones
              const topicIds = Array.isArray(topicId) ? topicId : [topicId];
              this.allSubtopics = this.allSubtopics.filter(s => !topicIds.includes(s.topic_id));
              this.allSubtopics = [...this.allSubtopics, ...newSubtopics];
              this.subtopics = newSubtopics;
              this.subtopicsFetchedFor[topicId] = true;
            } else {
              this.subtopics = response.data.docs;
            }
          }
        } catch (error) {
          console.error('Error fetching subtopics:', error);
          this.$toast.error('Failed to fetch subtopics');
        } finally {
          this.loadingSubtopics = false;
        }
      },

      debouncedFetchSubtopics: _.debounce(function(topicId) {
        this.fetchSubtopics(topicId, this.subtopicSearch);
      }, 500),

      selectConfiguration(topic, config) {
        topic.selectedConfigurationId = config._id;
        topic.selectedConfigurationName = config.name;
        topic.selectedTopicId = null;
        topic.selectedTopicName = null;
        topic.selectedSubtopicId = null;
        topic.linkedTopics = [];
        this.topics = [];
        this.subtopics = [];
        // Removed explicit closing: this.activeDropdowns[topic.id].config = false;
        this.configSearch = '';
        this.fetchTopics(config._id);
        this.$forceUpdate();
      },
      selectTopic(topicData, selectedTopic) {
        topicData.selectedTopicId = selectedTopic._id;
        topicData.selectedTopicName = selectedTopic.name;
        topicData.selectedSubtopicId = null;
        topicData.linkedTopics = [];
        this.subtopics = [];
        // Removed explicit closing: this.activeDropdowns[topicData.id].topic = false;
        this.topicSearch = '';
        this.fetchSubtopics(selectedTopic._id);
        this.$forceUpdate();
      },

      selectSubtopic(topic, subtopic) {
        if (!topic.linkedTopics) {
          topic.linkedTopics = [];
        }
        if (!topic.linkedTopics.includes(subtopic.name)) {
          topic.linkedTopics.push(subtopic.name);
        }
        topic.selectedSubtopicId = subtopic._id;
        this.subtopicSearch = '';
      },

      removeLinkedTopic(topic, index) {
        topic.linkedTopics.splice(index, 1);
      },

      toggleConfigDropdown(topic) {
        if (!this.activeDropdowns[topic.id]) {
          this.$set(this.activeDropdowns, topic.id, { config: false, topic: false, subtopic: false });
        }
        this.activeDropdowns[topic.id].config = !this.activeDropdowns[topic.id].config;
        this.$forceUpdate();
      },

      toggleTopicDropdown(topic) {
        if (!this.activeDropdowns[topic.id]) {
          this.$set(this.activeDropdowns, topic.id, { config: false, topic: false, subtopic: false });
        }
        this.activeDropdowns[topic.id].topic = !this.activeDropdowns[topic.id].topic;
        if (this.activeDropdowns[topic.id].topic) {
          this.topicSearch = '';
          // Only fetch if we haven't fetched for this config yet
          if (topic.selectedConfigurationId && !this.topicsFetchedFor[topic.selectedConfigurationId]) {
            this.fetchTopics(topic.selectedConfigurationId);
          } else if (topic.selectedConfigurationId) {
            // Show cached data
            this.topics = this.allTopics.filter(t => t.configuration_id === topic.selectedConfigurationId);
          }
        }
        this.$forceUpdate();
      },

      toggleSubtopicDropdown(topic) {
        if (!this.activeDropdowns[topic.id]) {
          this.$set(this.activeDropdowns, topic.id, { config: false, topic: false, subtopic: false });
        }
        this.activeDropdowns[topic.id].subtopic = !this.activeDropdowns[topic.id].subtopic;
        if (this.activeDropdowns[topic.id].subtopic) {
          this.subtopicSearch = '';
          // Only fetch if we haven't fetched for this topic yet
          if (topic.selectedTopicId && !this.subtopicsFetchedFor[topic.selectedTopicId]) {
            this.fetchSubtopics(topic.selectedTopicId);
          } else if (topic.selectedTopicId) {
            // Show cached data
            this.subtopics = this.allSubtopics.filter(s => s.topic_id === topic.selectedTopicId);
          }
        }
        this.$forceUpdate();
      },

      hideConfigDropdown(topic) {
        if (this.activeDropdowns[topic.id]) {
          this.activeDropdowns[topic.id].config = false;
          this.$forceUpdate();
        }
      },

      hideTopicDropdown(topic) {
        if (this.activeDropdowns[topic.id]) {
          this.activeDropdowns[topic.id].topic = false;
          this.$forceUpdate();
        }
      },

      hideSubtopicDropdown(topic) {
        if (this.activeDropdowns[topic.id]) {
          this.activeDropdowns[topic.id].subtopic = false;
          this.$forceUpdate();
        }
      },

      isDropdownOpen(topic, dropdownType) {
        // Ensure activeDropdowns entry exists
        if (!this.activeDropdowns[topic.id]) {
            this.$set(this.activeDropdowns, topic.id, { config: false, topic: false, subtopic: false, aiModel: false });
        }
        return this.activeDropdowns[topic.id] && this.activeDropdowns[topic.id][dropdownType];
      },
      
      toggleAiModelDropdown(topic) {
        if (!this.activeDropdowns[topic.id]) {
          this.$set(this.activeDropdowns, topic.id, { config: false, topic: false, subtopic: false, aiModel: false });
        }
        
         // specific toggle loop
        const keys = Object.keys(this.activeDropdowns[topic.id]);
        keys.forEach(k => {
             if(k !== 'aiModel') this.activeDropdowns[topic.id][k] = false;
        });
        
        this.activeDropdowns[topic.id].aiModel = !this.activeDropdowns[topic.id].aiModel;
        this.$forceUpdate();
      },
      
      hideAiModelDropdown(topic) {
          if (this.activeDropdowns[topic.id]) {
              this.activeDropdowns[topic.id].aiModel = false;
              this.$forceUpdate();
          }
      },
      
      selectAiModel(topic, modelValue) {
          topic.selectedAIModel = modelValue;
          this.activeDropdowns[topic.id].aiModel = false;
          this.$forceUpdate();
      },

      processResults(results, topic) {
        if (!topic) return;

        const processedQuestions = results.map((result, index) => {
          const q = result.question_id || {};
          let status = 'unprocessed';
          if (result.is_updated) {
            status = 'updated';
          } else if (result.is_flagged) {
            status = 'flagged';
          } else if (result.approved_by_ai) {
            status = 'approved';
          }

          // Extract subtopics from question's course_topics (type: "sub-topic")
          // This shows the actual DB subtopics, not just AI-identified ones
          let tags = [];
          if (q.course_topics && Array.isArray(q.course_topics)) {
            tags = q.course_topics
              .filter(ct => ct.type === 'sub-topic')
              .map(ct => ({
                _id: ct._id,
                name: ct.name
              }));
          } else {
            // Fallback to AI-identified subtopics if course_topics is not available
            tags = result.identified_subtopics || [];
          }

          return {
            id: result._id,
            number: index + 1,
            // Plain text fallback for listing view
            text: q.question || q.question_and_equation || q.equation || '',
            // HTML (text + equation, without images) for listing view
            listHtml: this.buildQuestionListHtml(q),
            // Rich HTML (text + equation + image) for edit modal
            richText: this.buildQuestionContent(q),
            status: status,
            options: (q.options || []).map((opt, i) => ({
              letter: String.fromCharCode(65 + i), // A, B, C, D
              // Plain text label
              text: opt.option || '',
              // Rich HTML for edit modal
              richText: this.buildOptionContent(opt),
              equation: opt.equation || '',
              imageUrl: opt.image_url || '',
              isCorrect: opt.is_correct,
              _id: opt._id
            })),
            tags: tags,
            type: result.question_nature
              ? result.question_nature.charAt(0).toUpperCase() + result.question_nature.slice(1)
              : '',
            isUpdated: result?.is_updated || false,
            aiFeedback: result?.ai_feedback,
            aiSolution: result?.ai_raw_response?.ai_question_solution,
            richSolution: this.buildSolutionContent(result?.ai_raw_response?.ai_question_solution),
            skipReason: result?.skip_reason,
            imageUrl: q.image_url || '',
            solutionImageUrl: q.solution_image_url || '',
            solutionText: q.solution || '',
            originalResult: result, // Keep original for reference
            isUserApproved: false // Initial state
          };
        });

        // Store in topic
        this.$set(topic, 'questions', processedQuestions);
        this.$set(topic, 'activeFilter', 'all');
        
        // Calculate counts
        this.updateTopicCounts(topic);

        // Ensure math equations render after DOM updates
        this.$nextTick(() => {
          this.applyMathQuill();
        });
      },

      processQuizResults(results, quiz) {
        if (!quiz) return;

        const processedQuestions = results.map((result, index) => {
          const q = result.question_id || {};
          let status = 'unprocessed';
          if (result.is_updated) {
            status = 'updated';
          } else if (result.is_flagged) {
            status = 'flagged';
          } else if (result.approved_by_ai) {
            status = 'approved';
          }

          let tags = [];
          if (q.course_topics && Array.isArray(q.course_topics)) {
            tags = q.course_topics
              .filter(ct => ct.type === 'sub-topic')
              .map(ct => ({
                _id: ct._id,
                name: ct.name
              }));
          } else {
            tags = result.identified_subtopics || [];
          }

          return {
            id: result._id,
            number: index + 1,
            text: q.question || q.question_and_equation || q.equation || '',
            listHtml: this.buildQuestionListHtml(q),
            richText: this.buildQuestionContent(q),
            status: status,
            options: (q.options || []).map((opt, i) => ({
              letter: String.fromCharCode(65 + i),
              text: opt.option || '',
              richText: this.buildOptionContent(opt),
              equation: opt.equation || '',
              imageUrl: opt.image_url || '',
              isCorrect: opt.is_correct,
              _id: opt._id
            })),
            tags: tags,
            type: result.question_nature
              ? result.question_nature.charAt(0).toUpperCase() + result.question_nature.slice(1)
              : '',
            isUpdated: result?.is_updated || false,
            aiFeedback: result?.ai_feedback,
            aiSolution: result?.ai_raw_response?.ai_question_solution,
            richSolution: this.buildSolutionContent(result?.ai_raw_response?.ai_question_solution),
            skipReason: result?.skip_reason,
            imageUrl: q.image_url || '',
            solutionImageUrl: q.solution_image_url || '',
            solutionText: q.solution || '',
            originalResult: result,
            isUserApproved: false
          };
        });

        // Store in quiz object
        this.$set(quiz, 'questions', processedQuestions);
        this.$set(quiz, 'activeFilter', 'all');
        
        // Calculate counts
        this.updateQuizCounts(quiz);

        this.$nextTick(() => {
          this.applyMathQuill();
        });
      },

      updateQuizCounts(quiz) {
        if (!quiz || !quiz.questions) return;
        
        quiz.filterCounts = {
          all: quiz.questions.length,
          approved: quiz.questions.filter(q => q.status === 'approved' && !q.isUpdated && !q.isUserApproved).length,
          updated: quiz.questions.filter(q => q.status === 'updated').length,
          flagged: quiz.questions.filter(q => q.status === 'flagged').length,
          unprocessed: quiz.questions.filter(q => q.status === 'unprocessed').length,
          approved_user: quiz.questions.filter(q => q.isUserApproved).length
        };
      },

      getTopicFilters(topic) {
        const counts = topic.filterCounts || { all: 0, approved: 0, updated: 0, flagged: 0, unprocessed: 0, approved_user: 0 };
        return [
          { key: 'all', label: 'All Results', count: counts.all, colorClass: 'dark' },
          { key: 'updated', label: 'Updated', count: counts.updated, colorClass: 'blue' },
          { key: 'approved', label: 'Approved (AI)', count: counts.approved, colorClass: 'green' },
          { key: 'approved_user', label: 'Approved (User)', count: counts.approved_user, colorClass: 'purple' },
          { key: 'flagged', label: 'Flagged', count: counts.flagged, colorClass: 'red' },
          { key: 'unprocessed', label: 'Unprocessed', count: counts.unprocessed, colorClass: 'gray' }
        ];
      },

      getFilteredQuestions(topic) {
        if (!topic || !topic.questions) return [];
        const filter = topic.activeFilter || 'all';
        if (filter === 'all') return topic.questions;
        if (filter === 'approved_user') return topic.questions.filter(q => q.isUserApproved);
        if (filter === 'approved') return topic.questions.filter(q => q.status === 'approved' && !q.isUpdated && !q.isUserApproved);
        return topic.questions.filter(q => q.status === filter);
      },

      getFilteredQuizQuestions(quiz) {
        if (!quiz || !quiz.questions) return [];
        const filter = quiz.activeFilter || 'all';
        if (filter === 'all') return quiz.questions;
        if (filter === 'approved_user') return quiz.questions.filter(q => q.isUserApproved);
        if (filter === 'approved') return quiz.questions.filter(q => q.status === 'approved' && !q.isUpdated && !q.isUserApproved);
        return quiz.questions.filter(q => q.status === filter);
      },

      updateTopicCounts(topic) {
          if (!topic || !topic.questions) return;
          const questions = topic.questions;
          topic.filterCounts = {
            all: questions.length,
            approved: questions.filter(q => q.status === 'approved' && !q.isUpdated && !q.isUserApproved).length,
            updated: questions.filter(q => q.status === 'updated').length,
            flagged: questions.filter(q => q.status === 'flagged').length,
            unprocessed: questions.filter(q => q.status === 'unprocessed').length,
            approved_user: questions.filter(q => q.isUserApproved).length
          };
      },

      containsHtml(str) {
        if (!str || typeof str !== 'string') return false;
        return /<\/?[a-z][\s\S]*>/i.test(str);
      },

      buildQuestionListHtml(question) {
        if (!question) return '';

        let html = '';

        // If backend already provides combined HTML, use it
        if (question.question_and_equation) {
          html = this.enhanceEquationsHtml(question.question_and_equation);
        } else {
          if (question.question) {
            // If it already contains HTML tags, trust it; otherwise escape
            html += this.containsHtml(question.question)
              ? question.question
              : this.escapeHtml(question.question);
          }

          if (question.equation) {
            html += '<br>' + this.enhanceEquationsHtml(question.equation);
          }
        }

        if (!html) return '';

        // Do NOT show images in the listing
        html = html.replace(/<img[^>]*>/gi, '');

        return html;
      },

      buildQuestionContent(question) {
        if (!question) return '';

        // Prefer pre-composed HTML if backend provides it
        if (question.question_and_equation) {
          return this.enhanceEquationsHtml(question.question_and_equation);
        }

        let html = '';
        if (question.question) {
          // If it already contains HTML tags, trust it; otherwise escape
          html += this.containsHtml(question.question)
            ? question.question
            : this.escapeHtml(question.question);
        }

        if (question.equation) {
          html += '<br>' + this.enhanceEquationsHtml(question.equation);
        }

        if (question.image_url) {
          html += `<br><img src="${question.image_url}" alt="Question image" />`;
        }

        return html;
      },

      buildOptionContent(option) {
        if (!option) return '';

        let html = '';
        if (option.option) {
          html += this.containsHtml(option.option)
            ? option.option
            : this.escapeHtml(option.option);
        }

        if (option.equation) {
          html += '<br>' + this.enhanceEquationsHtml(option.equation);
        }

        if (option.image_url) {
          html += `<br><img src="${option.image_url}" alt="Option image" />`;
        }

        return html;
      },
      
      splitEquationContent(content) {
        // Robust parser for mixed text and equations (supporting {{...}}, $$...$$, AND $...$)
        const parts = [];
        let currentIndex = 0;
        
        while (currentIndex < content.length) {
            // Find next delimiter start
            const openBrace = content.indexOf('{{', currentIndex);
            const openDoubleDollar = content.indexOf('$$', currentIndex);
            const openSingleDollar = content.indexOf('$', currentIndex);
            
            // Determine which comes first with precedence
            let openIndex = -1;
            let delimiterType = null; // 'brace', 'double_dollar', 'single_dollar'
            
            let possibleStarts = [];
            
            if (openBrace !== -1) {
                possibleStarts.push({ index: openBrace, type: 'brace' });
            }
            
            if (openDoubleDollar !== -1) {
                possibleStarts.push({ index: openDoubleDollar, type: 'double_dollar' });
            }
            
            if (openSingleDollar !== -1) {
                // Ignore single dollar if it's actually the start of a double dollar
                if (openDoubleDollar === -1 || openSingleDollar !== openDoubleDollar) {
                     possibleStarts.push({ index: openSingleDollar, type: 'single_dollar' });
                }
            }
            
            if (possibleStarts.length === 0) {
                 // No more equations
                parts.push({ type: 'text', content: content.substring(currentIndex) });
                break;
            }
            
            // Sort by index so we pick the EARLIEST delimiter
            possibleStarts.sort((a, b) => a.index - b.index);
            
            const selected = possibleStarts[0];
            openIndex = selected.index;
            delimiterType = selected.type;

            // Add text before equation
            if (openIndex > currentIndex) {
                parts.push({ type: 'text', content: content.substring(currentIndex, openIndex) });
            }
            
            if (delimiterType === 'brace') {
                // Parsing {{ ... }}
                let depth = 0;
                let closeIndex = -1;
                const contentStart = openIndex + 2;
                
                for (let i = contentStart; i < content.length; i++) {
                    const char = content[i];
                    if (char === '{') {
                        depth++;
                    } else if (char === '}') {
                        if (depth === 0) {
                             if (content[i+1] === '}') {
                                 closeIndex = i;
                                 break;
                             }
                        } else {
                            depth--;
                        }
                    }
                }
                
                if (closeIndex !== -1) {
                    const eq = content.substring(contentStart, closeIndex);
                    parts.push({ type: 'equation', content: eq });
                    currentIndex = closeIndex + 2;
                } else {
                    parts.push({ type: 'text', content: content.substring(openIndex) });
                    break;
                }
            } else if (delimiterType === 'double_dollar') {
                 // Parsing $$ ... $$
                const closeIndex = content.indexOf('$$', openIndex + 2);
                if (closeIndex !== -1) {
                    const eq = content.substring(openIndex + 2, closeIndex);
                    parts.push({ type: 'equation', content: eq });
                    currentIndex = closeIndex + 2;
                } else {
                     parts.push({ type: 'text', content: content.substring(openIndex) });
                     break;
                }
            } else if (delimiterType === 'single_dollar') {
                 // Parsing $ ... $
                const closeIndex = content.indexOf('$', openIndex + 1);
                // Ensure there is something inside
                if (closeIndex > openIndex + 1) {
                    const eq = content.substring(openIndex + 1, closeIndex);
                    parts.push({ type: 'equation', content: eq });
                    currentIndex = closeIndex + 1;
                } else {
                     parts.push({ type: 'text', content: content.substring(openIndex) });
                     break;
                }
            }
        }
        return parts;
      },

      buildSolutionContent(solution) {
        if (!solution) return '';
        
        // Use the robust splitter to identify equations
        const parts = this.splitEquationContent(solution);
        
        // DEBUG: Check how the solution is split
        console.log('[buildSolutionContent] Split parts:', parts);

        let html = '';
        parts.forEach(part => {
            if (part.type === 'equation') {
                // Render as MathQuill span
                html += `<span class="math-equation" data-latex="${part.content}"></span>`;
            } else {
                // Render as text (escape HTML)
                let text = this.escapeHtml(part.content);
                
                // 1. Format \textbf{...} -> <strong>...</strong>
                // Matches \textbf{ content } - non-greedy to handle multiple on same line
                text = text.replace(/\\textbf\{([^}]+)\}/g, '<strong>$1</strong>');
                
                // 2. Format \text{...} -> <span>...</span> (or just text stripping the wrapper)
                // Matches \text{ content }
                text = text.replace(/\\text\{([^}]+)\}/g, '<span>$1</span>');
                
                // 3. Handle newlines (both actual newlines and literal \n sequences)
                text = text.replace(/\\n/g, '<br>').replace(/\n/g, '<br>');
                
                html += text;
            }
        });
        
        return html;
      },

      enhanceEquationsHtml(raw) {
        if (!raw) return '';
        let html = raw.toString();

        // Replace LaTeX delimiters with spans that MathQuill can target
        // Block equations: $$...$$
        html = html.replace(/\$\$([^$]+)\$\$/g, (match, latex) => {
          return `<span class="math-equation" data-latex="${latex}"></span>`;
        });

        // Inline equations: $...$
        html = html.replace(/\$([^$]+)\$/g, (match, latex) => {
          return `<span class="math-equation" data-latex="${latex}"></span>`;
        });

        return html;
      },

      escapeHtml(text) {
        if (!text) return '';
        return text
          .toString()
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;');
      },

      renderRichContent(content) {
        if (!content) {
          return '';
        }
        // Preserve new lines while allowing provided HTML (images/equations) to render
        return content.toString().replace(/\n/g, '<br>');
      },

      applyMathQuill() {
        try {
          const MQGlobal = window.MathQuill || MathQuill;
          if (!MQGlobal || !MQGlobal.getInterface) {
            return;
          }
          const MQ = MQGlobal.getInterface(2);
          const nodes = this.$el.querySelectorAll('.math-equation');

          nodes.forEach(node => {
            if (node.dataset.mqRendered === 'true') return;

            const latex = (node.dataset.latex || node.textContent || '').trim();
            if (!latex) return;

            let instance;
            if (MQ.StaticMath) {
              instance = MQ.StaticMath(node);
            } else if (MQ.MathField) {
              instance = MQ.MathField(node, { readOnly: true });
            }

            if (instance && instance.latex) {
              instance.latex(latex);
              node.dataset.mqRendered = 'true';
            }
          });
        } catch (e) {
          // Fail silently if MathQuill is not available; text will still show
          console.error('MathQuill rendering error', e);
        }
      },



      isActiveTopic(topic) {
        return this.currentProcessingTopic && this.currentProcessingTopic === topic;
      },

      showAlert(title, message, type = 'info', confirmText = 'OK', onConfirm = null) {
        this.customAlert = {
          visible: true,
          title,
          message,
          type,
          confirmText,
          onConfirm
        };
      },

      closeAlert() {
        this.customAlert.visible = false;
        this.customAlert.onConfirm = null; // Clear callback
      },

      confirmAlert() {
        this.customAlert.visible = false;
        if (this.customAlert.onConfirm) {
          this.customAlert.onConfirm();
          this.customAlert.onConfirm = null;
        }
      },

      toggleApproval(question) {
        if (question.isUserApproved) {
            this.showAlert('Marked for Approval', 'Question marked for approval successfully.', 'success');
        }
        
        // Immediate visual update in the background list
        if (this.editingTopic && this.editingTopic.questions) {
            const questionInList = this.editingTopic.questions.find(q => q.id === question.id);
            if (questionInList) {
                this.$set(questionInList, 'isUserApproved', question.isUserApproved);
                // Also update status locally for immediate visual feedback
                if (question.isUserApproved) {
                    this.$set(questionInList, 'status', 'approved_user'); // Use distinct status for purple color
                } else {
                    // Revert to original status if unchecked, or keep as updated if it was updated
                    this.$set(questionInList, 'status', questionInList.isUpdated ? 'updated' : 'unprocessed'); 
                }
                
                // Update counts immediately
                if (this.currentProcessingTopic === this.editingTopic) {
                     this.updateQuizCounts(this.editingTopic);
                } else {
                     this.updateTopicCounts(this.editingTopic);
                }
            }
        }
      },

      mathCreator(id, data) {
        this.$nextTick(() => {
          setTimeout(() => {
            try {
              const span = document.getElementById(id);
              if (!span) return;

              const MQGlobal = window.MathQuill || window.Mathquill || window.mathquill || (typeof MathQuill !== 'undefined' && MathQuill);
              if (!MQGlobal || !MQGlobal.getInterface) return;

              const MQ = MQGlobal.getInterface(2);
              const mathField = MQ.MathField(span, {
                spaceBehavesLikeTab: false,
                handlers: {
                  edit: function () {},
                },
              });

              if (typeof data === 'string' && data) {
                if (!data.match(/\\\s/g)) {
                  data = data.replace(/\s+/g, '\\ ');
                }
                mathField.latex(data);
              }
            } catch (e) {
              console.error('MathQuill mathCreator error', e);
            }
          }, 10);
        });

        return '';
      },

      async fileChooser(type, indx) {
        try {
          const userId = storageService.get("uid");
          var input = document.createElement("input");
          input.type = "file";
          input.accept = "image/*";
          input.onchange = async (e) => {
            if (parseInt(e.target.files.length) > 1) {
              this.$toast.warning("You can only upload a single image file");
            } else {
              var formData = new FormData();
              formData.append("file", e.target.files[0]);
              formData.append("userId", userId);
              try {
                let res = await quizService.uploadImage(formData);
                if (res && res.data && res.data.link) {
                  if (type === "question") {
                    this.editingQuestion.imageUrl = res.data.link;
                  } else if (type === "solution") {
                    this.editingQuestion.solutionImageUrl = res.data.link;
                  } else if (type === "option" && indx !== undefined) {
                    this.$set(this.editingQuestion.options[indx], 'imageUrl', res.data.link);
                  }
                  this.$toast.success("Image uploaded successfully");
                }
              } catch (error) {
                console.error("Image upload error", error);
                this.$toast.error(error.response?.data?.message || "Failed to upload image");
              }
            }
          };
          input.click();
        } catch (e) {
          this.$toast.error(e.message);
        }
      },

      deleteImage(type, indx) {
        if (type === "question") {
          this.editingQuestion.imageUrl = '';
        } else if (type === "solution") {
          this.editingQuestion.solutionImageUrl = '';
        } else if (type === "option" && indx !== undefined) {
          this.$set(this.editingQuestion.options[indx], 'imageUrl', '');
        }
        this.$toast.success("Image removed");
      }
    },
    beforeDestroy() {
      if (this.loadingInterval) {
        clearInterval(this.loadingInterval)
      }
      if (this.socket) {
        this.socket.disconnect();
      }
    }
  };
</script>

<style src="./quiz-fix-by-ai.css" scoped></style>
